export default __webpack_public_path__ + "static/media/wolfgang-reitzle.f0babd55.png";